import React from "react";
import styles from "./approach.module.css";
import { Section, SectionIntro } from "../../../../COMPONENTS/UI";
import Reveal from "../../../../COMPONENTS/ANIMATION/Reveal";
import { approach } from "../../../../CONTENT/sponsors";

const Approach = () => (
  <Section tone="cloud" id="approach" labelledBy="approach-title">
    <SectionIntro
      id="approach-title"
      eyebrow="How KUR delivers"
      title="Six systems working as one."
      lead="Every KUR site runs on the same network, patient database, quality team, CTMS, marketing engine and start-up department."
    />
    <ol className={styles.grid}>
      {approach.map((a, i) => (
        <Reveal as="li" key={a.title} delay={(i % 2) * 0.08} className={styles.item}>
          <div className={styles.head}>
            <span className={styles.num}>{String(i + 1).padStart(2, "0")}</span>
            <span className={styles.fact}>{a.fact}</span>
          </div>
          <h3 className={styles.title}>{a.title}</h3>
          <p className={styles.text}>{a.text}</p>
        </Reveal>
      ))}
    </ol>
  </Section>
);

export default Approach;
